import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 236;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '3e1e74e2-f718-4397-8a25-2855a9459d9c-236';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
